import * as React from 'react';

export const PaymentTitle = ({ children }: {children: React.ReactNode}) => {
	return (
		<div style={{ marginBottom: '12px', fontSize: '18px', lineHeight: '25px' }}>
			<b>{children}</b>
		</div>
	);
};
